export default "/images/9898df7bf71617c4f1649d4941c3d019.avif";